/**
 * Helper function to find the scrollable parent element
 * @param element - The element to start searching from
 * @returns The scrollable parent element or null if not found
 */
export const findScrollableParent = (
  element: HTMLElement | null
): HTMLElement | null => {
  if (
    !element ||
    element === document.body ||
    element === document.documentElement
  ) {
    return null;
  }

  const style = window.getComputedStyle(element);
  const overflow = style.overflow;
  const overflowY = style.overflowY;
  const overflowX = style.overflowX;

  const isScrollable = /(auto|scroll)/.test(overflow + overflowY + overflowX);

  if (isScrollable && element.scrollHeight > element.clientHeight) {
    return element;
  }

  return findScrollableParent(element.parentElement);
};
